/**
 * Zentrale Marken-Assets â€” eine Quelle fÃ¼r PreisExpert / PE One Logos.
 * Cache-Bust (`v=`) erhÃ¶hen, wenn Dateien in public/assets ausgetauscht werden.
 */

const PE_LOGO_VERSION = '20260802';

/** PreisExpert-Hauptlogo (carbon / since 2018) â€” relativ fÃ¼r die App */
export const PE_LOGO_SRC = `/assets/PElogo.png?v=${PE_LOGO_VERSION}`;

/**
 * Absolute URL fÃ¼r E-Mails / Newsletter (Clients laden kein /assets der App).
 * Zeigt immer das deployte Hosting-Asset â€” kein Imgur/WordPress.
 */
export const PE_LOGO_PUBLIC_URL = `https://pe-one-app.web.app/assets/PElogo.png?v=${PE_LOGO_VERSION}`;

/** PE One Produktlogo */
export const PE_ONE_LOGO_SRC = `/assets/logo.png?v=${PE_LOGO_VERSION}`;

/** PE Pulse Wordmark */
export const PE_PULSE_LOGO_SRC = `/assets/pepulse-logo.png?v=${PE_LOGO_VERSION}`;

/** PE Pulse Homescreen / PWA Icon (512) */
export const PE_PULSE_ICON_SRC = `/assets/pepulse-icon-512.png?v=${PE_LOGO_VERSION}c`;

/**
 * PE Pulse Web-App-Manifest â€” unter /pepulse/ ablegen, damit iOS start_url "./"
 * auf /pepulse/ auflÃ¶st (nicht Root wie bei manifest.json start_url ".").
 */
export const PE_PULSE_MANIFEST_HREF = `/pepulse/manifest.json?v=${PE_LOGO_VERSION}c`;

/** CUTIER Hub â€” Dateien nach public/assets/ legen */
const CUTIER_ASSET_VERSION = '20260818b';
export const CUTIER_LOGO_SRC = `/assets/cutier-logo.png?v=${CUTIER_ASSET_VERSION}`;
export const RAMIN_DELL_LOGO_SRC = `/assets/ramin-dell-logo.png?v=${CUTIER_ASSET_VERSION}`;
export const TANJA_DELL_LOGO_SRC = '/assets/tanja-dell-lockenzeremonie-logo.png';
/** Absolute URL fÃ¼r Einladungs-Mails (Clients laden kein /assets der App). */
export const TANJA_DELL_LOGO_PUBLIC_URL =
  `https://pe-one-app.web.app/assets/tanja-dell-lockenzeremonie-logo.png?v=${CUTIER_ASSET_VERSION}`;

/**
 * Cutier Web-App-Manifest â€” unter /cutier/ ablegen, damit iOS/Android start_url "./"
 * auf /cutier/ auflÃ¶st (nicht Root / PE One wie bei manifest.json start_url ".").
 */
export const CUTIER_MANIFEST_HREF = `/cutier/manifest.json?v=20260820f`;
export const CUTIER_HUB_URL = 'https://cutier-hub.web.app';

